import React from 'react';
import PropTypes from 'prop-types';

export default function IconFloatMessage({size = '55px', color = '#303030'}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.87988 8.63965H8.63965V7.19971H2.87988V8.63965ZM2.87988 6.47998H11.5195V5.03955H2.87988V6.47998ZM2.87988 4.31983H11.5195V2.87988H2.87988V4.31983ZM0 14.3999V1.43994C0 1.04395 0.141602 0.704591 0.423828 0.422365C0.706055 0.140138 1.04492 -0.000487014 1.44043 1.26716e-06H12.96C13.1289 1.26716e-06 13.2871 0.0253919 13.4355 0.0766614C13.6348 0.145997 13.8154 0.261232 13.9775 0.423341C14.2598 0.705568 14.4004 1.04443 14.4004 1.43994V10.0796C14.4004 10.4756 14.2588 10.8149 13.9766 11.0972C13.6943 11.3794 13.3555 11.52 12.96 11.5195H2.87988L0 14.3999Z"
        fill={color}
      />
    </svg>
  );
}

IconFloatMessage.propTypes = {
  size: PropTypes.string,
  color: PropTypes.string
};
